import { removeUserMedia } from "../../api/media";
import { setIdle, setImageLoading } from "../../store/common/appStateSlice";
import { setImages } from "../../store/media/mediaSlice";

export const removeMedia = (id) => async (dispatch, getState) => {
  try {
    dispatch(setImageLoading());
    await removeUserMedia(id);
    const images = getState().media.images;
    dispatch(setImages(images.filter((i) => i.id !== id)));
    dispatch(setIdle());
  } catch (error) {
    console.log(error);
    dispatch(setIdle());
  }
};
